import React from 'react';
import { TableInstance } from 'react-table';

import { TenantBankAccount } from '@work4all/models/lib/Classes/TenantBankAccount.entity';
import { SortDirection } from '@work4all/models/lib/DataProvider';

import { IEntityTable } from '../entity-table/EntityTable';
import { EntityTableV8 } from '../entity-table/EntityTableV8';
import { useEntityDataTableV8 } from '../entity-table/use-entity-data-table-v8';
import schema from '../schemata/tenant-bank-account-table-schema.json';

const defaultSort = [{ field: 'id', direction: SortDirection.DESCENDING }];

export const TenantBankAccountTable = React.forwardRef<
  TableInstance,
  IEntityTable
>(function TenantBankAccountTable(_props) {
  const { entity: entityType } = schema as never;
  const tableProps = {
    schema: schema as never,
    defaultSort,
  };
  const dataTable = useEntityDataTableV8<TenantBankAccount, never>({
    ...tableProps,
  });

  return (
    <EntityTableV8
      entityType={entityType}
      {...dataTable}
      {..._props}
      actions={{
        groupingEnabled: false,
        createWidget: false,
      }}
      overrides={{
        areas: {
          left: null,
          right: null,
        },
      }}
    />
  );
});
